import { useEffect } from "react";
import { useMap } from "react-leaflet";
import { maplibreGL } from "@maplibre/maplibre-gl-leaflet";
import "maplibre-gl/dist/maplibre-gl.css";
import {
  MAP_STYLE_URL,
  MAP_ATTRIBUTION,
  applyGrabBasemap,
} from "../map/openFreeMap";

function OpenFreeMapLayer() {
  const map = useMap();

  useEffect(() => {
    if (!map) return undefined;

    const layer = maplibreGL({
      style: MAP_STYLE_URL,
      attribution: MAP_ATTRIBUTION,
      interactive: false,
    }).addTo(map);

    const glMap = layer.getMaplibreMap();
    const onLoad = () => applyGrabBasemap(glMap);
    if (glMap) {
      if (glMap.loaded()) onLoad();
      else glMap.once("load", onLoad);
    }

    return () => {
      if (glMap) glMap.off("load", onLoad);
      if (map.hasLayer(layer)) map.removeLayer(layer);
    };
  }, [map]);

  return null;
}

export default OpenFreeMapLayer;
